import { render, staticRenderFns } from "./EventScrollList.vue?vue&type=template&id=3845e018&scoped=true"
import script from "./EventScrollList.vue?vue&type=script&lang=js"
export * from "./EventScrollList.vue?vue&type=script&lang=js"
import style0 from "./EventScrollList.vue?vue&type=style&index=0&id=3845e018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3845e018",
  null
  
)

export default component.exports